module.exports = __webpack_public_path__ + "76097df6ae39c324518b5d77a39af946.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/credit-card.png
// module id = 2627
// module chunks = 0